import cfopMetadata from './data/metadata.json';
import type { CfopDataVersion } from './types.js';

export const CFOP_DATA_VERSION: CfopDataVersion = cfopMetadata as CfopDataVersion;
